import { render } from "./LiquorLicense.vue?vue&type=template&id=df6353ec&scoped=true"
import script from "./LiquorLicense.vue?vue&type=script&lang=js"
export * from "./LiquorLicense.vue?vue&type=script&lang=js"

import "./LiquorLicense.vue?vue&type=style&index=0&id=df6353ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6353ec"]])

export default __exports__